import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Person\UpdatePersonVigilanceController::__invoke
* @see app/Http/Controllers/Person/UpdatePersonVigilanceController.php
* @route '/api/person/{person}/vigilance'
*/
const UpdatePersonVigilanceController = (args: { person: string | number | { id: string | number } } | [person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdatePersonVigilanceController.url(args, options),
    method: 'put',
})

UpdatePersonVigilanceController.definition = {
    methods: ["put"],
    url: '/api/person/{person}/vigilance',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Person\UpdatePersonVigilanceController::__invoke
* @see app/Http/Controllers/Person/UpdatePersonVigilanceController.php
* @route '/api/person/{person}/vigilance'
*/
UpdatePersonVigilanceController.url = (args: { person: string | number | { id: string | number } } | [person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { person: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { person: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            person: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        person: typeof args.person === 'object'
        ? args.person.id
        : args.person,
    }

    return UpdatePersonVigilanceController.definition.url
            .replace('{person}', parsedArgs.person.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Person\UpdatePersonVigilanceController::__invoke
* @see app/Http/Controllers/Person/UpdatePersonVigilanceController.php
* @route '/api/person/{person}/vigilance'
*/
UpdatePersonVigilanceController.put = (args: { person: string | number | { id: string | number } } | [person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdatePersonVigilanceController.url(args, options),
    method: 'put',
})

export default UpdatePersonVigilanceController